import { render, staticRenderFns } from "./ContestChampGross.vue?vue&type=template&id=958363b2&scoped=true&"
import script from "./ContestChampGross.vue?vue&type=script&lang=js&"
export * from "./ContestChampGross.vue?vue&type=script&lang=js&"
import style0 from "./ContestChampGross.vue?vue&type=style&index=0&id=958363b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958363b2",
  null
  
)

export default component.exports